import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  LoadMore,
  Loader,
  recordsContain,
} from '@frontendmentorio/design-system-v2';

import LockedCard from './LockedCard';
import SolutionCard from 'features/solutions/Card';

export default function Solutions({ challenge }) {
  const currentUser = useSelector(selectCurrentUser);
  const isStarted = recordsContain(currentUser?.unlockedHubs, challenge);
  const hasSubscription = currentUser?.hasActiveSubscription;

  const {
    data: { data: attempts },
  } = useFetchInfinite(
    `/api/v3/learner/solutions?filter=challenge|${challenge.id}`
  );

  const isCompleted = attempts?.length > 0;
  const isUnlocked =
    (isStarted && hasSubscription) || currentUser?.admin || isCompleted;

  const {
    data: { data: solutions, meta },
    isLoading,
    setPage,
  } = useFetchInfinite(
    isUnlocked ? `/api/v3/solutions?filter=challenge|${challenge.id}` : null
  );

  if (isUnlocked) {
    if (!solutions?.length) return <Loader className="py-12" />;

    return (
      <div className="flex flex-col items-center gap-6">
        <ul className="gap-5 grid w-full tablet:grid-cols-2 desktop:grid-cols-3">
          {solutions?.map((solution) => (
            <SolutionCard key={solution.id} solution={solution} />
          ))}
        </ul>

        {meta?.page.next && (
          <LoadMore
            isLoading={isLoading}
            onClick={() => setPage(meta.page.next)}
          />
        )}
      </div>
    );
  }

  if (hasSubscription && !isStarted) {
    return (
      <LockedCard CTA="Start challenge" href={`/challenges/${challenge.slug}`}>
        Start this challenge to see solutions
      </LockedCard>
    );
  }

  return (
    <LockedCard CTA="Unlock Pro" href="/pro">
      Complete this challenge to see solutions or upgrade to Pro to see
      solutions early
    </LockedCard>
  );
}
